import { render } from "./ToastificationContent.vue?vue&type=template&id=06c377d8&scoped=true"
import script from "./ToastificationContent.vue?vue&type=script&lang=js"
export * from "./ToastificationContent.vue?vue&type=script&lang=js"

import "./ToastificationContent.vue?vue&type=style&index=0&id=06c377d8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06c377d8"]])

export default __exports__